<template>
  <div class="buypileh5-Container" >
    <div class="bg">
     <img  class="bg-item" v-lazy="bg"  alt="" >
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      bg:'https://frontend-mam.oss-cn-hangzhou.aliyuncs.com/cps/images/update_news.png'+"?t="+ Date.now(),
    }
  },
  created(){
  },
  methods:{}
   
}
</script>

<style lang="less" scoped> 
.buypileh5-Container{
    position: relative;
   .bg{
       width: 100%;
       position: absolute;
       left: 0;
       top: 0;
       display: flex;
       flex-direction: column;
       .bg-item{
        width: 100%;
       }
   }

}
</style>